export const FEATURE_TYPE = { backend: 'B', frontend: 'F' }
